/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ThreeDotDropDown from "./ThreeDotDropDown";
import {
  measureSpanWidth,
  calculateRenderedList,
} from "../../../../utils/GOINestedTitlesHelpers";
import HeaderItem from "./HeaderItem";
import LastItem from "./LastItem";
import "./index.css";

/**
 * Component to render nested titles for objects with multiple parent nodes.
 * It dynamically calculates and renders a list of titles based on available width.
 * items - The list of items representing the nested titles.
 * outerWidth - The width of the outer container to determine the rendering of items.
 * mainHeaders - Flag to indicate if the main headers are being rendered.
 */
const GOINestedTitles = ({ items, outerWidth, mainHeaders = false }) => {
  // Slice the items array to exclude the last item if not rendering main headers
  const localItems = items.slice(
    0,
    mainHeaders ? items.length : items.length - 1
  );
  // Define the last item, which is different if rendering main headers
  const lastItem = mainHeaders ? { width: 0 } : items[items.length - 1];
  // State to hold the list of items to be rendered
  const [renderedList, setRenderedList] = React.useState([]);
  React.useEffect(() => {
    // Add width to each item considering the ">" width and zoom
    localItems.forEach((item) => {
      const spanWidth = measureSpanWidth(item.name) + 24.14;
      item.width = spanWidth;
    });
    // Calculate the width for the last item if not rendering main headers
    if (!mainHeaders) lastItem.width = measureSpanWidth(lastItem.name) + 60;
    // Calculate the list of items to be rendered based on the outer width
    const newList = calculateRenderedList(outerWidth, localItems, lastItem);
    setRenderedList(newList);
  }, [outerWidth]);
  // Get the ID of the last item in the list
  const lastItemId = items[items.length - 1].id;
  return (
    <div className="flex-h">
      {/* Render the list of items or the ThreeDotDropDown component if the item is an array */}
      {renderedList?.length > 0 &&
        renderedList?.map((item, index) => (
          <React.Fragment key={index}>
            {Array.isArray(item) ? (
              <ThreeDotDropDown
                key={index}
                items={item}
                hideLastCap={mainHeaders && renderedList?.length - 1 === index}
              />
            ) : (
              <HeaderItem key={index} item={item} lastItemId={lastItemId} />
            )}
          </React.Fragment>
        ))}
      {/* Render the LastItem component */}
      {!mainHeaders && <LastItem key="last" item={lastItem} />}
    </div>
  );
};
export default GOINestedTitles;